import './index.scss';
import React, {Component, PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledInput from '../../../claim/shared/components/claim-fields/labeled-input';
import RgaSearchModel from '../../search/state/rga-search-model';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import UsefulLinksPanel from '../../search/components/useful-links-panel';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function onChangeFormFieldListValue(propertyName, props, value) {

    const valueList = value ? value.split(',') : [];

    if (value) {

        props.actions.updateRgaSearchObject(propertyName, valueList);

    } else {

        props.actions.resetRgaSearchObjectListValues(propertyName);

    }

}

function onClickResetRgaSearchFormBtn() {

    // Reset the search model object and selected domains

    this.actions.resetRgaSearchModelObject();
    this.actions.resetRgaSearchSelectedDomains();
    this.actions.updateSearchQueryString('');
    this.actions.updateSearchByDropDown('RGA_NUMBER');

}

function onClickSearchButton() {

    this.actions.onSearchMassUpdate();

}

function handleOnMassUpdate() {

    this.actions.openMassUpdateModal();

}

function handleOnMassUpload() {

    this.actions.openMassUploadModal();

}
class MassUpdate extends Component {
    state = {
        filesSortedCollection: [],
        searchFields: {
            analysts: '',
            rgaNumbers: '',
            warrantyClaims: ''
        },
        selectedFiles: []
    };

    render() {

        return (
            <section className='mass-update'>

                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='rga-homepage-aside'>
                    <UsefulLinksPanel
                        onMassUpdate={this.props::handleOnMassUpdate}
                        onMassUpload={this.props::handleOnMassUpload}
                        security={this.props.security}
                    />
                </aside>
                <main className='rga-homepage-home-main'>
                    <h3>{'Mass Updates'}</h3>

                    <div className='row'>
                        <LabeledInput
                            className='part-request'
                            isEditable={true}
                            label='RGA Number'
                            maxLength={2000}
                            onChange={onChangeFormFieldListValue.bind(event, 'rgaNumbers', this.props)}
                            tabIndex='10'
                            value={this.props.rgaSearchModel.rgaNumbers.join(',')}
                        />

                        <LabeledInput
                            className='part-request'
                            isEditable={true}
                            label='Warranty Claim'
                            maxLength={2000}
                            onChange={onChangeFormFieldListValue.bind(event, 'warrantyClaimNumbers', this.props)}
                            tabIndex='11'
                            value={this.props.rgaSearchModel.warrantyClaimNumbers.join(',')}
                        />

                        <LabeledInput
                            className='part-request'
                            isEditable={true}
                            label='Analyst'
                            maxLength={2000}
                            onChange={onChangeFormFieldListValue.bind(event, 'analystIds', this.props)}
                            tabIndex='13'
                            value={this.props.rgaSearchModel.analystIds.join(',')}
                        />
                    </div>
                    <h3 className='inlineInfoMessage'>{'Use \'commas\' to separate values in multiple RGA searches'}</h3>
                    <section className='button-group'>
                        <button
                            className='secondary'
                            onClick={onClickResetRgaSearchFormBtn.bind(this.props)}
                        >
                            <FormattedMessage id='Clear Form'/>
                        </button>
                        <button
                            className='primary'
                            onClick={onClickSearchButton.bind(this.props)}
                        >
                            <FormattedMessage id='SEARCH'/>
                        </button>
                    </section>
                </main>
            </section>
        );

    }
}

MassUpdate.displayName = 'MassUpdate';
MassUpdate.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    rgaSearchModel: PropTypes.instanceOf(RgaSearchModel).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default MassUpdate;



// WEBPACK FOOTER //
// ./src/rga/mass-update/components/index.js